import "./ColorPickerComponent.scss";
import React, {useState, useCallback, useEffect} from 'react';
import {SketchPicker} from 'react-color'

interface ColorPickerComponentProps {
    onColorChange?: any;
    themeColor: any;
    canEdit?: boolean;
}

const ColorPickerComponent = (props: ColorPickerComponentProps) => {
    const {onColorChange, themeColor, canEdit} = props;
    const [displayColorPicker, setDisplayColorPicker] = useState(false);
    const [color, setColor] = useState(themeColor || {
        r: '241',
        g: '112',
        b: '19',
        a: '1',
    });

    useEffect(() => {
        setColor(themeColor);
    }, [themeColor]);

    const handleClick = () => {
        canEdit && setDisplayColorPicker(!displayColorPicker);
    };

    const handleClose = () => {
        setDisplayColorPicker(false);
    };

    const handleChange = useCallback((color: any) => {
        setColor(color.rgb);
        onColorChange(color.rgb);
    }, [onColorChange]);


    return (
        <div className={'color-picker-component'}>
            <div className="swatch" onClick={handleClick}>
                <div className="color" style={{background: `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`}}/>
            </div>
            {displayColorPicker && (
                <div className="popover">
                    <div className="cover" onClick={handleClose}/>
                    <SketchPicker
                        color={color}
                        onChange={handleChange}
                    />
                </div>
            )}
        </div>
    );

};

export default ColorPickerComponent;
